<i
  [class]="styleClass ? icon + ' ' + styleClass : icon"
  [pTooltip]="tooltip"
  tooltipPosition="top"></i>
